const state = {
  gameInfo: {},
  deviceType: 'pc',
  navArticleType: 'all'
}

export default state
